import React, { Component } from 'react';
import style from './select.module.scss';

export default class SelectInput extends Component {

	constructor(props) {
		super(props);
		this.selectInput = React.createRef();
	}
	render() {
		if (this.props.focusState) {
			this.selectInput.current.focus({preventScroll: true});
		}
		let name = (this.props.field && this.props.field.name ? this.props.field.name : this.props.name);
		let value = (this.props.field && this.props.field.value ? this.props.field.value : this.props.value);
		let onChange = (this.props.field && this.props.field.onChange ? this.props.field.onChange : this.props.onChange);
		let onBlur = (this.props.field && this.props.field.onBlur ? this.props.field.onBlur : this.props.onBlur);
		let label = this.props.label;
		let errorCondition = (this.props.form && this.props.form.touched[name] && this.props.form.errors[name] ? true : (this.props.errorCondition !== undefined ? this.props.errorCondition : false));
		let errorMessage = (this.props.form && this.props.form.errors[name] ? this.props.form.errors[name] : this.props.errorMessage);
		let autoComplete = (this.props.autoComplete !== undefined ? (this.props.autoComplete === 'off' || this.props.autoComplete === false ? 'off' : 'on') : 'on');
		let options = [];
		let hideLabel = (this.props.hideLabel !== undefined ? this.props.hideLabel : false);
		let delimiter = (this.props.delimiter !== undefined ? this.props.delimiter : ',');
		if (value === undefined && this.props.default !== undefined)value = this.props.default;
		if (this.props.options) {
			if (Array.isArray(this.props.options)) {
				for (let option of this.props.options) {
					if (typeof option === 'object') {
						options.push({
							value: option.value,
							label: option.label||option.text,
							selected: option.selected||false,
						})
					}
					else {
						options.push({
							value: option,
							label: option,
							selected: (option === value),
						})
					}
				}
			}
			if (typeof this.props.options === 'string') {
				for (let option of this.props.options.split(delimiter)) {
					options.push({
						value: option,
						label: option,
						selected: (option === value),
					})
				}
			}
		}
		let { className } = this.props;
		className = (className||'').split(' ');
		className.push(style.container);
		className = className.filter((item) => item);
		return (
			<div className={className.join(' ')}>
				{!hideLabel && <label htmlFor={name}>{label}</label> }
				<div className={style.fieldContainer}>
					<select aria-label={label} autoComplete={autoComplete} className={style.inputField} id={name} ref={this.selectInput} placeholder={this.props.placeholder} name={name} value={value} onChange={onChange} onBlur={onBlur}>
						{this.props.placeholder && <option disabled value="" selected>{this.props.placeholder}</option>}
						{ options.map((item, i) => {
							return (
								<option key={item.value} value={item.value}>{item.label}</option>
							)
						}) }
					</select>
					<div className={ [style.error, (errorCondition ? style.active : '')].join(' ') }>{errorMessage}</div>
				</div>
			</div>
		)
	}
}


/*
					{ (this.props.lines === undefined || this.props.lines === 1) && <input type="text" autoComplete={autoComplete} className={style.inputField} id={name} ref={this.selectInput} placeholder={this.props.placeholder} name={name} value={value} onChange={onChange} onBlur={onBlur} /> }
					{ this.props.lines >= 2 && <textarea autoComplete={autoComplete} className={style.inputField} id={name} ref={this.selectInput} placeholder={this.props.placeholder} rows={this.props.lines} name={name} value={value} onChange={onChange} onBlur={onBlur} /> }




import React, {Component} from 'react'
import style from './select.module.scss';

class Select extends Component {
	render() {
		if(this.props.value) {
			var values = this.props.value;
			var type;
			if (Array.isArray(values)) {
				const item = values[0];
				const isArray = item instanceof Array;
				if (typeof item === 'string') {
					type = 'array'; 
				} else if(isArray === false) {
					type = 'object';
				}
			} else {
				type = typeof values;
			}
		}
		switch(type) {
			case 'string':
				return (
					<select onChange={this.props.changeHandler} defaultValue="" aria-label={this.props.label} className={style.selectInput} name={this.props.name}>
						<option value="" disabled hidden>{this.props.placeholder}</option>
						<option value={this.props.value}>{this.props.value}</option>
						}
					</select>
				)
			case 'array':
				const options = values.map((value, index) =>
				  <option key={index} value={value}>{value}</option>
				);
				return (
					<select onChange={this.props.changeHandler} defaultValue="" aria-label={this.props.label} className={style.selectInput} name={this.props.name}>
						<option disabled value="" hidden>{this.props.placeholder}</option>
						{options}
					</select>
				)
			case 'object':
				const multiOptions = values.map((value, index) =>
				  <option key={index} value={value.value}>{value.label}</option>
				);
				return (
					<select onChange={this.props.changeHandler} defaultValue="" aria-label={this.props.label} className={style.selectInput} name={this.props.name}>
						<option value="" disabled hidden>{this.props.placeholder}</option>
						{multiOptions}
					</select>
				)
			default:
				return (
					<p>I need props!</p>
				)
		}
	}
}

export default Select;
 */